import { gql } from '@apollo/client'

export const AUTHENTICATE_CUSTOMER = gql`
    mutation AuthenticateCustomer($input: AuthenticateCustomerInput!, $phone: String!) {
        authenticateCustomer(input: $input, phone: $phone) {
            errors {
                field
                message
            }
            user {
                id
            }
        }
    }
`
